var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"commandRef",staticClass:"flex h-full w-full flex-col overflow-hidden",on:{"keydown":_setup.onKeyDown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }